import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Button } from 'react-bootstrap';
import { required } from '../../../../_utils/validators';
import { renderField } from '../../common/FormsControls.jsx';


const TogglePasswordButton = ({ on, onClick }) =>{
  let className = on ? 'icon-eye-off' : 'icon-eye';
  return <Button variant='outline-secondary' onClick={ onClick }>
    <i className={'icon ' + className }></i>{' '}
    { on ? gettext('Скрыть пароль') : gettext('Показать пароль')}
  </Button>
}

TogglePasswordButton.PropTypes={
  on: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

const PasswordField = ({ label, placeholder, name }) => {
  const [show, setShow] = useState(false);

  const handleClick = () => {
    setShow(!show);
  }

  return <Field label={ label }
                placeholder={ placeholder }
                component={ renderField }
                validate={[required]}
                type={ show ? 'text' : 'password' }
                withInputGroup={ true }
                inputGroupAppendButton={ <TogglePasswordButton on={ show } onClick={ handleClick }/> }
                name={ name }/>
}

PasswordField.PropTypes={
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}

export default PasswordField;